import React, { useId, useState } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { PrimaryButton } from '../components/button';
import { Constants } from '../lib/const/constants';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { ToastContainer,toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import "react-phone-input-2/lib/style.css";
import { encryptPayload } from '../utils/encryption';


export default function Register() {
    const navigate = useNavigate();
    const { type: regType } = useParams();
    var deviceId = useId();
    const [loading, setLoading] = useState(false);
    const [pin, setPin] = useState("");
    const [confirmPin, setConfirmPin] = useState("");
    const [email, setEmail] = useState("");
    const [fullname, setFullname] = useState("");
    const [mobile, setMobile] = useState("");
    const [pinMessage, setPinMessage] = useState("");
const [pinError, setPinError] = useState(false);
     const [showPin, setShowPin] = useState(false);
  const [showConfirmPin, setShowConfirmPin] = useState(false);
  const [occupation, setOccupation] = useState('NA');
  const [coupon, setCoupon] = useState('');


   const submitHandler = async () => {
  setLoading(true);

  //  Account type check
  if (regType === "select_account") {
    toast.error("Please select an account type.");
    setLoading(false);
    return;
  }

  //  Check all mandatory fields (email, mobile, fullname for individual, pin, confirmPin)
  if (
    email.trim() === "" ||
    mobile.trim() === "" ||
    pin.trim() === "" ||
    confirmPin.trim() === "" ||
    (regType === "individual" && fullname.trim() === "")
  ) {
    toast.error("Please fill all the mandatory fields.");
    setLoading(false);
    return;
  }

  //  PIN validation
  if (!pin || !confirmPin) {
    setPinError(true);
    toast.error("PIN and Confirm PIN are required");
    setLoading(false);
    return;
  }
//  confirmPin PIN validation
  if (pin !== confirmPin) {
    setPinError(true);
    toast.error("PINs must match.");
    setPinMessage("PIN and confirmation mismatched")
    setLoading(false);
    return;
  }

  // 4. Success case
  setPinMessage("PIN and confirmation matched");
  setPinError(false);

  sessionStorage.setItem("enterPin", pin);
  sessionStorage.setItem("deviceid", deviceId);

  try {
    const encryptedPayload = await encryptPayload({
        screen_name: "CREATE_ACCOUNT_1",
        meta: { enterPin: pin },
        device_id: deviceId,
        user_id: Date.now(),
      });
    const dropresponse = await axios.post(
      Constants.BASE_URL + "API-FX-159-DROPSCREEN",
      encryptedPayload,
      {
        headers: { fx_key: Constants.SUBSCRIPTION_KEY },
      }
    );

    console.log(dropresponse.data);
    submitHandlerNationality();
  } catch (dropError) {
    console.log(dropError.response?.data || dropError.message);
    toast.error(dropError.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};



    const submitHandlerNationality = async () => {
        setLoading(true)
        if (email.trim() == "" || mobile.trim() == "" || pin.trim() == "" || confirmPin.trim() == "") {
            toast.error("Please fill all the mandatory fields.");
            setLoading(false)
        }
        else {
            const selectedTitle = sessionStorage.getItem('select_title');
            const selectedOccupation = sessionStorage.getItem('occupation');
            const selectedPurposeOfAccount = sessionStorage.getItem('purpose_of_account');
            const destinationCountry = sessionStorage.getItem('destination_country');
            const nationality = sessionStorage.getItem('nationality');
            const firstName = sessionStorage.getItem('firstName')
            const middleName = sessionStorage.getItem('middleName')
            const lastName = sessionStorage.getItem('lastName')
            const enterPin = sessionStorage.getItem('enterPin')
            var deviceId = sessionStorage.getItem('deviceid');
            const fullPhone = mobile; 
const countryCode = sessionStorage.getItem('user_country_code'); 

// Remove country code prefix from mobile
const actualPhone = fullPhone.startsWith(countryCode)
  ? fullPhone.slice(countryCode.length)
  : fullPhone;
            const signUpencryptedPayload = await encryptPayload({
                "title_id": "1",
                "first_name": "NA",
                "middle_name": "NA",
                "last_name": "NA",
                "country_code": countryCode,
                "nationality": nationality,
                "password": enterPin,
                "password_confirmation": enterPin,
                "country_id": "231",
                "phone": actualPhone,
                "email": email,
                "is_banking_user": 2,
                "type": "standard",
                "occupation": selectedOccupation,
                "account": selectedPurposeOfAccount,
                "destination_country": destinationCountry,
                "domain":1,
                "coupon": coupon,
                "platform": 'web',
                "extraParamValidation": 'trustedfromweb'
            });
            await axios.post(Constants.BASE_URL + "API-FX-105-CustomerSignup", signUpencryptedPayload, {
                headers: {
                    fx_key: Constants.SUBSCRIPTION_KEY
                }
            }).then(async(response) => {
                console.log(JSON.stringify(response.data.data));
                setAsyncData('userid', JSON.stringify(response.data.data.id))
                setAsyncData('user_full_name', response.data.data.full_name)
                setAsyncData('user_email', response.data.data.email)
                setAsyncData('user_phone', response.data.data.phone)
                setAsyncData('user_first_name', response.data.data.first_name)
                setAsyncData('user_middle_name', response.data.data.middle_name)
                setAsyncData('user_last_name', response.data.data.last_name)
                setAsyncData('user_country_code', response.data.data.country_code)
                setAsyncData('user_country_id', response.data.data.country_id)
                setAsyncData('user_country_name', response.data.data.country_name)
                setAsyncData('user_registration_step', response.data.data.registration_step)
                setAsyncData('registrationToken', response.data.token)
                setAsyncData('user_workspaces', JSON.stringify(response.data.data.workspaces))
                setAsyncData('registrationType',regType);
                
                const dropscreenencryptedPayload = await encryptPayload({
                    screen_name: "NATIONALITY_2",
                    meta: { title_id: selectedTitle, country_code: "44", nationality: nationality, password: enterPin, country_id: "231", phone: mobile, email: email, is_banking_user: 2, type: "standard", destination_country: destinationCountry, first_name: firstName, middle_name: middleName, last_name: lastName, registrationToken: response.data.token, user_registration_step: response.data.data.registration_step,registrationType:regType === "individual" ? "personal" : regType },
                    device_id: deviceId,
                    user_id: response.data.data.id
                });

                await axios.post(Constants.BASE_URL + "API-FX-159-DROPSCREEN", dropscreenencryptedPayload, {
                    headers: {
                        fx_key: Constants.SUBSCRIPTION_KEY
                    }
                }).then(dropresponse => {
                    console.log(dropresponse.data);
                    setLoading(false)
                    navigate("/VerifyPhone");
                }).catch(dropError => {
                    setLoading(false)
                    toast.error(dropError.response.data.message)
                })
            }).catch(error => {   
                toast.error(error.response.data.message);
                setLoading(false)
            })
        }
    }

    const setAsyncData = async (key, value) => {
        sessionStorage.setItem(key, value);
    }


    return (
      

           <div className="min-h-screen w-full bg-white flex flex-col">
  <div className="w-full border-b border-[#0B214E33] py-6 px-6">
    <img src="/fx_logo_old.png" alt="FXMaster Logo" className="w-[160px]" />
  </div>

<div className="flex-grow flex justify-center px-4 sm:px-6 md:px-10 lg:px-20 xl:px-32 pt-8">
    <div className="w-full max-w-[700px] xl:max-w-[800px] mx-auto py-8">
      <h1 className="text-2xl font-semibold mb-6 cursor-pointer flex items-center"  onClick={() => navigate("/account-type")}> <img className='mr-1' src="/back-arrow.svg" /> {regType === "business" ? "You Are Registering As A Business Account" : "You Are Registering As An Individual (Personal) Account"} </h1>
      <ToastContainer />

      {/* Form Fields */} 
     
 <div className="mb-4">
  <PhoneInput
    country={'gb'}
    onlyCountries={["gb"]}
    disableDropdown={true}
    value={mobile}
    placeholder="Enter Mobile Number*"
    onChange={(phone, country) => {
      setMobile(phone);
      sessionStorage.setItem('user_country_code', country.dialCode);
      sessionStorage.setItem('full_phone_number', `+${phone}`);
    }}
    inputClass="w-full p-3 outline-none rounded-lg bg-[#DEE9FC] placeholder:text-custom-neutral-900 placeholder:text-sm"
    inputStyle={{
      width: '100%',
      background: '#DEE9FC',
      borderRadius: '10px',
      padding: '12px 39px',
      fontSize: '14px',
      border: 'none',
      color: '#000', // Text color
    }}
    buttonStyle={{
      background: '#DEE9FC',
      border: 'none',
      borderTopLeftRadius: '10px',
      borderBottomLeftRadius: '10px', 
    }}
    dropdownStyle={{
      maxHeight: '200px',
    }}
    enableSearch
  />
</div>




      {regType === 'individual' && (
        <>
          <div className="mb-4">
            <input
              type="fullname"
              placeholder="Enter Your Full Name*"
              className="w-full p-3 outline-none rounded-lg bg-[#DEE9FC] placeholder:text-custom-neutral-900 placeholder:text-sm"
              value={fullname}
                //pattern="[A-Za-z ]*"
                onChange={(e) => {
      const onlyLetters = e.target.value.replace(/[^A-Za-z ]/g, "");
      setFullname(onlyLetters);
    }}
              //onChange={(e) => setFullname(e.target.value)}
            />
          </div>
          <div className="mb-4">
            <input
              type="email"
              placeholder="Enter Your Email*"
              className="w-full p-3 outline-none rounded-lg bg-[#DEE9FC] placeholder:text-custom-neutral-900 placeholder:text-sm"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="mb-4" style={{display:'none'}} >
            <input
              type="text"
              placeholder="Enter Your Occupation*"
               value={occupation}
              className="w-full p-3 outline-none rounded-lg bg-[#DEE9FC] placeholder:text-custom-neutral-900 placeholder:text-sm"
               onChange={(e) => {
      const onlyLetters = e.target.value.replace(/[^A-Za-z ]/g, "");
      setOccupation(onlyLetters);
    }}
            />
          </div>
        </>
      )}

      {regType === 'business' && (
        <div className="mb-4">
          <input
            type="email"
            placeholder="Enter Your Email Id*"
            className="w-full p-3 outline-none rounded-lg bg-[#DEE9FC] placeholder:text-custom-neutral-900 placeholder:text-sm"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
      )}

      <div className="mb-4 relative">
        <input
          type={showPin ? "text" : "password"}
          placeholder="Enter Your 6-Digit Pin"
          className="pin-input w-full p-3 outline-none rounded-lg bg-[#DEE9FC] placeholder:text-custom-neutral-900 placeholder:text-sm"
          value={pin}
          onChange={(e) => setPin(e.target.value)}
        />
         <button
          type="button"
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-600"
          onClick={() => setShowPin(!showPin)}
        >
          {showPin ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
        </button>
      </div>

     <div className="mb-6">
  <div className="relative">
    <input
      type={showConfirmPin ? "text" : "password"}
      placeholder="Re-Enter Your 6-Digit Pin"
      className="pin-input w-full p-3 outline-none rounded-lg bg-[#DEE9FC] placeholder:text-custom-neutral-900 placeholder:text-sm"
      value={confirmPin}
      onChange={(e) => setConfirmPin(e.target.value)}
    />
    <button
      type="button"
      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-600"
      onClick={() => setShowConfirmPin(!showConfirmPin)}
    >
      {showConfirmPin ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
    </button>
  </div>

  <div className="relative">
    <input
      type={"text"}
      placeholder="Enter Your Referral Code If Any"
      className="pin-input w-full p-3 outline-none rounded-lg bg-[#DEE9FC] placeholder:text-custom-neutral-900 placeholder:text-sm my-4"
      value={coupon}
      onChange={(e) => setCoupon(e.target.value)}
    />
  </div>

  {pinMessage && (
    <p className={`mt-1 text-sm ${pinError ? "text-red-600" : "text-green-600"}`}>
      {pinMessage}
    </p>
  )}
</div>


      <PrimaryButton  onClick={submitHandler} label="Continue" loading={loading} />

      {/* <div className="mt-6 text-center">
        Already Registered?
        <button
          onClick={() => navigate("/login")}
          className="text-sm font-semibold text-blue-800 ml-1"
        >
          Login Here
        </button>
      </div> */}
    </div>
  </div>
</div>


    );
}